export default __webpack_public_path__ + "static/media/skype-logo-transparent-white.5c82345d.png";